import '@formatjs/intl-locale/polyfill';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'intersection-observer';
import 'cross-fetch/polyfill';
import { ResizeObserver } from '@juggle/resize-observer';

if (!window.ResizeObserver) {
  window.ResizeObserver = ResizeObserver;
}

if (!window.crypto) {
  (window as any).crypto = (window as any).msCrypto;
}
